import { useTranslation } from "react-i18next";
import { ButtonAtom } from "../../../../components/atoms/atom";
import OtpBoxInput from "./OtpBoxInput";
import LoginStepHeader from "./LoginStepHeader";
import LoginSubmitButton from "./LoginSubmitButton";

function LoginCodeStep({
	email,
	code,
	codeError,
	countdown,
	isRequesting,
	isVerifying,
	onCodeChange,
	onVerify,
	onResend,
	onChangeEmail,
}) {
	const { t } = useTranslation();

	return (
		<>
			<LoginStepHeader
				eyebrow={t("login.verify-eyebrow").toUpperCase()}
				heading={t("login.verify-heading")}
				subtext={
					<>
						{t("login.otp-sent-to")} <strong>{email}</strong>
					</>
				}
			/>

			<div className="login-field">
				<OtpBoxInput
					value={code}
					onChange={onCodeChange}
					onSubmit={onVerify}
					hasError={!!codeError}
					autoFocus
				/>
				{codeError ? (
					<span className="login-error login-error--center">
						{t(codeError)}
					</span>
				) : (
					<span className="login-hint">{t("login.enter-code")}</span>
				)}
			</div>

			<LoginSubmitButton
				onClick={onVerify}
				disabled={isVerifying || code.length < 6}
				loading={isVerifying}
				labelKey="login.sign-in"
			/>

			<div className="login-footer">
				<span className="login-footer-text">
					{t("login.no-code")}&nbsp;
					{countdown > 0 ? (
						<span className="login-countdown">
							{t("login.resend-code")} ({countdown}s)
						</span>
					) : (
						<ButtonAtom
							className="login-link"
							onClick={onResend}
							disabled={isRequesting}
						>
							{t("login.resend-code")}
						</ButtonAtom>
					)}
				</span>
				<ButtonAtom
					className="login-link login-link--back"
					onClick={onChangeEmail}
				>
					← {t("login.change-email")}
				</ButtonAtom>
			</div>
		</>
	);
}

export default LoginCodeStep;
